import { Tooltip } from '@material-ui/core';
import React, { ReactNode, useEffect, useState } from 'react';

import { useFormBuilderStore } from '~/src/dash/components/forms/formBuilder/contexts';
import { SimpleSwitch } from '~/src/dash/components/forms/formBuilder/ParameterRow/editors/common/SimpleSwitch';
import { IconV2 } from '~/src/dash/components/icons/IconV2';
import { Col, Cols, spacing } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

export interface ISwitchWithTooltipProps {
  valueKey: string;
  tooltip?: string | NonNullable<ReactNode>;
  key: string; // MUST BE UNIQUE
  activeLabel?: string;
  inactiveLabel?: string;
  convertResponseValue?: (value: any) => boolean;
  convertSwitchValue?: (value: boolean) => any;
}

export const SwitchWithTooltip = ({
  valueKey,
  tooltip = '',
  activeLabel = '',
  inactiveLabel = '',
  convertResponseValue,
  convertSwitchValue,
}: ISwitchWithTooltipProps) => {
  const { object, defaultObject } = useFormBuilderStore();

  const [isChecked, setIsChecked] = useState<boolean>(
    convertResponseValue ? convertResponseValue(object[valueKey]) : object[valueKey],
  );

  const handleSwitch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(e.target.checked);
    object[valueKey] = convertSwitchValue ? convertSwitchValue(e.target.checked) : e.target.checked;
  };

  useEffect(() => {
    return () => {
      object[valueKey] = defaultObject[valueKey];
    };
  }, []);

  return (
    <Cols gap={spacing.base} style={{ alignItems: 'center' }}>
      <Col>
        <SimpleSwitch
          isChecked={isChecked}
          handleSwitch={handleSwitch}
          label={isChecked ? activeLabel : inactiveLabel}
          key={valueKey}
          inputID={valueKey}
        />
      </Col>
      {tooltip && (
        <Col>
          <Tooltip title={tooltip} placement='top' interactive>
            <div style={{ display: 'flex' }}>
              <IconV2 name='info-static' color={publicaColors.gray} />
            </div>
          </Tooltip>
        </Col>
      )}
    </Cols>
  );
};
